import { NamedIconsType } from '@europrocurement/l2d-icons/types';
import { faBell, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { associateIcon, createIcon } from './userAction';
import { publisherIcon } from './publication';
import { mailIcon } from './general';
import { invoiceIcon } from './invoicesIcons';

export const reminderIcon: NamedIconsType = {
    props: {
        icon: faBell,
    },
    name: 'reminder',
    displayName: 'Rappel',
};

export const reminderPublisherIcon: NamedIconsType = {
    props: {
        icon: {
            prefix: 'fad',
            iconName: (reminderIcon.props.icon as IconDefinition).iconName,
        },
        option: {
            prefix: 'fas',
            iconName: (publisherIcon.props.icon as IconDefinition).iconName,
        },
    },
    name: 'reminderPublisher',
    displayName: 'Rappel fournisseur',
};

export const reminderMailIcon: NamedIconsType = {
    props: {
        icon: {
            prefix: 'fad',
            iconName: (reminderIcon.props.icon as IconDefinition).iconName,
        },
        option: {
            prefix: 'fas',
            iconName: (mailIcon.props.icon as IconDefinition).iconName,
        },
    },
    name: 'reminderMail',
    displayName: 'Mail de rappel',
};

export const createReminderPublisher: NamedIconsType = {
    props: {
        icon: {
            prefix: 'fad',
            iconName: (reminderIcon.props.icon as IconDefinition).iconName,
        },
        option: {
            prefix: 'fas',
            iconName: (createIcon.props.icon as IconDefinition).iconName,
        },
    },
    name: 'createReminder',
    displayName: 'Créer un rappel fournisseur',
};

export const associateInvoiceToReminderPublisherIcon: NamedIconsType = {
    props: {
        icon: {
            prefix: 'fad',
            iconName: (invoiceIcon.props.icon as IconDefinition).iconName,
        },
        option: {
            prefix: 'fas',
            iconName: (associateIcon.props.icon as IconDefinition).iconName,
        },
    },
    name: 'associateInvoice',
    displayName: 'Associer une facture à ce rappel fournisseur',
};
